import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasApproverGuideSchema = withDefaults({
  type: 'tas-approver-guide',
  fields: [
    { kind: 'attribute', name: 'companyId' },
    { kind: 'attribute', name: 'planLabel' },
    { kind: 'attribute', name: 'templateCodes' },
    { kind: 'attribute', name: 'title' },
    { kind: 'attribute', name: 'internalAppeal' },
    { kind: 'attribute', name: 'notificationDate' },
    { kind: 'attribute', name: 'launchDate' },
    { kind: 'attribute', name: 'sourceUrl' },
    { kind: 'attribute', name: 'sections' },
    { kind: 'attribute', name: 'versionRef' },
    { kind: 'attribute', name: 'lockVersion' },
    { kind: 'attribute', name: 'psm' },
    { kind: 'attribute', name: 'approverMode' },
    { kind: 'attribute', name: 'approversLockVersion' },
    { kind: 'attribute', name: 'approvers' },
    { kind: 'attribute', name: 'otherRoleHolders' },
    { kind: 'attribute', name: 'retiredAt' },
    { kind: 'attribute', name: 'retiredNote' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
  ],
});

export default TasApproverGuideSchema;
